// AUTO-GENERATED by execution/gen_festival_facts.py — DO NOT EDIT.
// Source of truth: business/ishvaram/data/domain/astrology/festivals.yaml
// (rules 23/24/29 — engine-verified, never hand-typed). Dates are NOT
// projected here — the backend calendar API owns year dates at runtime.
// Regenerate: uv run python execution/gen_festival_facts.py

export interface FestivalFacts {
  readonly rule_type: string;
  readonly hindu_month: string;
  readonly hindu_month_hi: string;
  /** Krishna paksha only: this fortnight's month name in Amanta calendars. */
  readonly amanta_month: string;
  readonly amanta_month_hi: string;
  readonly paksha: string;
  readonly paksha_hi: string;
  readonly tithi: string;
  readonly tithi_hi: string;
  readonly fasting: boolean;
}

export const FESTIVAL_FACTS: Readonly<Record<string, FestivalFacts>> = {
  makar_sankranti: {
    rule_type: "sankranti",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  vasant_panchami: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Panchami",
    tithi_hi: "पंचमी",
    fasting: false,
  },
  maha_shivaratri: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "Magha",
    amanta_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturdashi",
    tithi_hi: "चतुर्दशी",
    fasting: true,
  },
  holika_dahan: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  holi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  ugadi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: false,
  },
  chaitra_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: true,
  },
  ram_navami: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Navami",
    tithi_hi: "नवमी",
    fasting: true,
  },
  hanuman_jayanti: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  akshaya_tritiya: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Tritiya",
    tithi_hi: "तृतीया",
    fasting: false,
  },
  buddha_purnima: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  guru_purnima: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  raksha_bandhan: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  janmashtami: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "Shravana",
    amanta_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ashtami",
    tithi_hi: "अष्टमी",
    fasting: true,
  },
  ganesh_chaturthi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: false,
  },
  anant_chaturdashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Chaturdashi",
    tithi_hi: "चतुर्दशी",
    fasting: true,
  },
  pitru_paksha_start: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: false,
  },
  mahalaya_amavasya: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    tithi_hi: "अमावस्या",
    fasting: false,
  },
  sharad_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: true,
  },
  dussehra: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Dashami",
    tithi_hi: "दशमी",
    fasting: false,
  },
  karwa_chauth: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  dhanteras: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: false,
  },
  narak_chaturdashi: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturdashi",
    tithi_hi: "चतुर्दशी",
    fasting: false,
  },
  diwali: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    tithi_hi: "अमावस्या",
    fasting: false,
  },
  govardhan_puja: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    tithi_hi: "अमावस्या",
    fasting: false,
  },
  bhai_dooj: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Dwitiya",
    tithi_hi: "द्वितीया",
    fasting: false,
  },
  chhath_puja: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Shashthi",
    tithi_hi: "षष्ठी",
    fasting: true,
  },
  dev_diwali: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  mauni_amavasya: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "Pausha",
    amanta_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Amavasya",
    tithi_hi: "अमावस्या",
    fasting: true,
  },
  magha_gupt_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: true,
  },
  ashadha_gupt_navratri_start: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Pratipada",
    tithi_hi: "प्रतिपदा",
    fasting: true,
  },
  pausha_putrada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  shattila_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "Pausha",
    amanta_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  jaya_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  vijaya_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "Magha",
    amanta_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  amalaki_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  papmochani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "Phalguna",
    amanta_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  kamada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  varuthini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "Chaitra",
    amanta_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  mohini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  apara_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    amanta_month: "Vaisakha",
    amanta_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  nirjala_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  yogini_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "Jyeshtha",
    amanta_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  devshayani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  kamika_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "Ashadha",
    amanta_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  shravana_putrada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  aja_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "Shravana",
    amanta_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  parsva_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  indira_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  papankusha_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  rama_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  devuthani_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  utpanna_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    amanta_month: "Kartika",
    amanta_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  mokshada_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  saphala_ekadashi: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    amanta_month: "Margashirsha",
    amanta_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: true,
  },
  pradosh_vrat_jan_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_jan_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "Pausha",
    amanta_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_feb_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_feb_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "Magha",
    amanta_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_mar_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_mar_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "Phalguna",
    amanta_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_apr_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_apr_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "Chaitra",
    amanta_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_may_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_may_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    amanta_month: "Vaisakha",
    amanta_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_jun_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_jun_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "Jyeshtha",
    amanta_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_jul_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_jul_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "Ashadha",
    amanta_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_aug_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_aug_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "Shravana",
    amanta_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_sep_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_sep_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_oct_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_oct_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_nov_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_nov_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    amanta_month: "Kartika",
    amanta_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_dec_shukla_2026: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  pradosh_vrat_dec_krishna_2026: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    amanta_month: "Margashirsha",
    amanta_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Trayodashi",
    tithi_hi: "त्रयोदशी",
    fasting: true,
  },
  sankashti_chaturthi_jan: {
    rule_type: "tithi",
    hindu_month: "Magha",
    hindu_month_hi: "माघ",
    amanta_month: "Pausha",
    amanta_month_hi: "पौष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_feb: {
    rule_type: "tithi",
    hindu_month: "Phalguna",
    hindu_month_hi: "फाल्गुन",
    amanta_month: "Magha",
    amanta_month_hi: "माघ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_mar: {
    rule_type: "tithi",
    hindu_month: "Chaitra",
    hindu_month_hi: "चैत्र",
    amanta_month: "Phalguna",
    amanta_month_hi: "फाल्गुन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_apr: {
    rule_type: "tithi",
    hindu_month: "Vaisakha",
    hindu_month_hi: "वैशाख",
    amanta_month: "Chaitra",
    amanta_month_hi: "चैत्र",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_may: {
    rule_type: "tithi",
    hindu_month: "Jyeshtha",
    hindu_month_hi: "ज्येष्ठ",
    amanta_month: "Vaisakha",
    amanta_month_hi: "वैशाख",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_jun: {
    rule_type: "tithi",
    hindu_month: "Ashadha",
    hindu_month_hi: "आषाढ़",
    amanta_month: "Jyeshtha",
    amanta_month_hi: "ज्येष्ठ",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_jul: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "Ashadha",
    amanta_month_hi: "आषाढ़",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_aug: {
    rule_type: "tithi",
    hindu_month: "Bhadrapada",
    hindu_month_hi: "भाद्रपद",
    amanta_month: "Shravana",
    amanta_month_hi: "श्रावण",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_sep: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_oct: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "Ashvina",
    amanta_month_hi: "आश्विन",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_nov: {
    rule_type: "tithi",
    hindu_month: "Margashirsha",
    hindu_month_hi: "मार्गशीर्ष",
    amanta_month: "Kartika",
    amanta_month_hi: "कार्तिक",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  sankashti_chaturthi_dec: {
    rule_type: "tithi",
    hindu_month: "Pausha",
    hindu_month_hi: "पौष",
    amanta_month: "Margashirsha",
    amanta_month_hi: "मार्गशीर्ष",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Chaturthi",
    tithi_hi: "चतुर्थी",
    fasting: true,
  },
  solar_eclipse_feb_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  lunar_eclipse_mar_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: true,
  },
  solar_eclipse_aug_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  lunar_eclipse_sep_2026: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  solar_eclipse_feb_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  lunar_eclipse_feb_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  solar_eclipse_aug_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: true,
  },
  lunar_eclipse_aug_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  nag_panchami: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Panchami",
    tithi_hi: "पंचमी",
    fasting: false,
  },
  hariyali_teej: {
    rule_type: "tithi",
    hindu_month: "Shravana",
    hindu_month_hi: "श्रावण",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Tritiya",
    tithi_hi: "तृतीया",
    fasting: true,
  },
  onam: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  navami_shraddh: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "Bhadrapada",
    amanta_month_hi: "भाद्रपद",
    paksha: "Krishna",
    paksha_hi: "कृष्ण पक्ष",
    tithi: "Navami",
    tithi_hi: "नवमी",
    fasting: false,
  },
  durgashtami: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ashtami",
    tithi_hi: "अष्टमी",
    fasting: true,
  },
  makar_sankranti_2027: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: false,
  },
  maha_navami: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Navami",
    tithi_hi: "नवमी",
    fasting: true,
  },
  sharad_purnima: {
    rule_type: "tithi",
    hindu_month: "Ashvina",
    hindu_month_hi: "आश्विन",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Purnima",
    tithi_hi: "पूर्णिमा",
    fasting: false,
  },
  tulsi_vivah: {
    rule_type: "tithi",
    hindu_month: "Kartika",
    hindu_month_hi: "कार्तिक",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "Shukla",
    paksha_hi: "शुक्ल पक्ष",
    tithi: "Ekadashi",
    tithi_hi: "एकादशी",
    fasting: false,
  },
  vaikuntha_ekadashi: {
    rule_type: "",
    hindu_month: "",
    hindu_month_hi: "",
    amanta_month: "",
    amanta_month_hi: "",
    paksha: "",
    paksha_hi: "",
    tithi: "",
    tithi_hi: "",
    fasting: true,
  },
} as const;
